import React, { useState, useEffect, useCallback, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useRealtimeDrivers } from 'Core/hooks';
import { useIntl } from 'react-intl';
import moment from 'moment';

//Components
import {
    InputNumeric,
    SelectMenu,
    DatePicker,
    FileUpload,
    Required,
    TextArea,
    Select,
    Button,
    Modal,
    Form,
} from "@gpstrackit/gtc-react-controls";
import { NotificationContainer } from "Components/Notifications";
import { NotificationManager } from 'Components/Notifications';
import { Grid } from '@mui/material';

//Helpers
import { OrderData } from 'Core/data/Helpers';
import { GetFormatForMoment } from '../../../../core/hooks/utils';
import { setContactId } from '../../../../core/hooks';

//Views
import CreateEditDriverTask from '../createEditDriverTask';

//Actions
import {
    openModalCreateDriverTasks,
    uploadAttachment,
    catalogLoad,
} from 'Redux/actions';
import {
    maintenanceMSDTSearchMaintenanceDriverTasks,
    maintenanceMSDTSearchDriverScheduledTasks,
    maintenanceMSDTGetDriverScheduledTask,
    maintenanceMSDTGetDriverTasksScheduledRequest,
    maintenanceMSDTCreateEditAlertSubscriber,
    maintenanceMSDTCreateUpdateDriverScheduledTask,
    reset
} from './redux/slice';

//Styles
import './styles.scss';

const ScheduleDriverTask = (props) => {
    const { refresh } = props
    const { messages, locale } = useIntl();
    const dispatch = useDispatch();
    const formRef = Form.useForm();


    const { user } = useSelector(state => state.securityRedux);
    const {
        loadingCreateUpdateDriverScheduledTask,
        loadingAlertSubscriberResponse,
        loadingListDriverScheduledTasks,
        listTotalDriversScheduledTasks,
        loadingScheduledDriverTask,
        listDriverScheduledTasks,
        alertSubscriberResponse,
        scheduledDriverTaskId,
        scheduledDriverTask,
        loadingDriverTasks,
        driverTasks,
        open,
        driverId,
        loading,
    } = useSelector(state => state.maintenanceScheduleDriverTasksRedux);

    const response = useSelector(state => state.maintenanceScheduleDriverTasksRedux.scheduleDriverTaskResult);
    const { createDriverTaskResponse } = useSelector(state => state.maintenanceCreateDriverTasksRedux);
    const openCreateDriverTasks = useSelector(state => state.maintenanceCreateDriverTasksRedux.open);
    const { uploadedAttachment, loadingUploadFile } = useSelector(state => state.commomRedux);
    const loadingDrivers = useSelector(state => state.catalogsRedux.loadingDrivers);
    const loadingContacts = useSelector(state => state.catalogsRedux.loadingContacts);

    const driversList = useRealtimeDrivers({ trackFields: ['id', 'name', 'externalId', 'disabled', 'tags'] });
    const contactsList = useSelector(state => state.catalogsRedux.contacts);

    const ALERT_TYPES = [
        { id: "Reminder", name: messages['reminder'] },
        { id: "DueNow", name: messages['dueNow'] },
        { id: "PastDue", name: messages['pastDue'] }
    ];

    const TIME_UNITS = [
        { id: "Hours", name: messages['hours'] },
        { id: "Days", name: messages['days'] },
        { id: "Months", name: messages['months'] }
    ];

    const [formData, setFormData] = useState({ subscribers: [], attachments: [] });

    const [tasks, setTasks] = useState([]);
    const [drivers, setDrivers] = useState([]);
    const [contacts, setContacts] = useState([]);
    const [selectedTask, setSelectedTask] = useState();

    useEffect(() => {
        if (open) {
            dispatch(catalogLoad(['contacts', 'drivers']));
            dispatch(maintenanceMSDTSearchMaintenanceDriverTasks({}))
        }
    }, [open]);

    useEffect(() => {
        if (listDriverScheduledTasks && listDriverScheduledTasks.length > 0) {
            /* let newDriversTask = []
            tasks.map(task => {
                if (listDriverScheduledTasks.filter(sTask => sTask.driverTaskId == task.id).length == 0) {
                    newDriversTask.push(task)
                }
            })
            setTasks(newDriversTask) */
        }
    }, [listDriverScheduledTasks])

    const handleClose = () => {
        dispatch(reset())
        setFormData({ subscribers: [], attachments: [] })
    };

    useEffect(() => {
        if (driverTasks && driverTasks.length) {
            let newTasks = [
                ...[{ id: -1, name: messages['scheduleDriverTask_createNewTask'] }],
                ...OrderData(driverTasks || [], 'name'),
            ];
            setTasks(newTasks);
        }
    }, [driverTasks]);

    useEffect(() => {
        if (scheduledDriverTask && driversList && driversList?.length && driverTasks && driverTasks?.length) {
            setData(scheduledDriverTask);
        }
    }, [scheduledDriverTask, driversList, driverTasks]);

    useEffect(() => {
        if (scheduledDriverTaskId) {
            dispatch(maintenanceMSDTGetDriverScheduledTask({ id: scheduledDriverTaskId }));
        }
    }, [scheduledDriverTaskId]);

    useEffect(() => {
        if (driverId && driversList?.length) {
            let driver = driversList.find(d => d.driverId == driverId);
            setFormData({ ...formData, driver: driver });
            setTimeout(() => {
                formRef.setValues({ ...formData, driver: driver })
            }, 100);
        }
    }, [driverId, driversList]);

    useEffect(() => {
        if (contactsList && contactsList?.length) {
            const newContacts = setContactId(contactsList);
            setContacts(OrderData(newContacts, 'title'));
        }
    }, [contactsList]);

    useEffect(() => {
        if (open && alertSubscriberResponse) {
            dispatch(reset({ alertSubscriberResponse: null }))
            handleSuccess();
        }
    }, [alertSubscriberResponse, open]);

    const handleSuccess = () => {
        NotificationManager.success(
            messages['success'],
            messages['scheduleDriverTask_taskScheduledSuccess'],
            3000,
            null,
            null,
            'success',
        );

        if (refresh) refresh();

        if (formData?.driver?.driverId) {
            dispatch(maintenanceMSDTSearchDriverScheduledTasks({ id: formData.driver.driverId }))
            dispatch(maintenanceMSDTGetDriverTasksScheduledRequest({ openSearch: '', driverId: formData.driver.driverId }))
        }

        if (scheduledDriverTask?.id && window.location.pathname.includes("driverDetail")) {
        }

        if (window.location.pathname.includes("maintenance/main")) {

        }
        handleClose();
    }

    const filterDriversByTask = (value) => {
        const filterDrivers = listTotalDriversScheduledTasks.filter(driverTask => driverTask.driverTaskId === value.id)

        let didChange = false

        const newDriversArray = []

        drivers.map(driver => {
            if (filterDrivers.filter(fDriver => fDriver.driverId === driver.driverId).length === 0) newDriversArray.push(driver)
            else didChange = true
        })

        if (didChange) setDrivers(newDriversArray)
    }

    const setTask = (value) => {
        setSelectedTask(value)
        if (value.id === -1) {
            dispatch(openModalCreateDriverTasks({ open: true }))
            setTimeout(() => {
                formRef.setValues({ task: null })
            }, 50);
        }
        else {
            let newTimeUnit = TIME_UNITS.find(timeUnit => timeUnit.id === value.timeUnit);
            let data = {
                task: value,
                estimatedCost: value.estimatedCost,
                frequency: getValidFrequency(newTimeUnit?.id, value.frequency),
                timeUnit: newTimeUnit,
            }
            const finalData = { ...data, date: getDueDate(data.timeUnit.id, data.frequency) }
            setFormData({ ...formData, ...finalData });
            let timer = setTimeout(() => {
                formRef.setValues({
                    ...formData,
                    ...finalData,
                    maintenanceServiceNotes: value?.description || '',
                    maintenanceServiceAttachments: value?.files
                });
                timer = null;
            }, 100);
        }
    }

    useEffect(() => {
        if (open && response && response.id) {
            createDriverScheduledTaskAlert();
        }
    }, [response, open]);

    const setData = (data) => {
        let newDate = "";
        let newFrequency = data.frequency;
        if (!data.dueDate) {
            newDate = "";
        } else if (data.dueDate && data.dueDate == "0000-00-00 00:00:00") {
            newFrequency = getValidFrequency(TIME_UNITS.find(timeUnit => timeUnit.id === data.timeUnit)?.id, data.frequency);
            newDate = getDueDate(TIME_UNITS.find(timeUnit => timeUnit.id === data.timeUnit)?.id, data.frequency);
        } else newDate = new Date(data.dueDate);

        let newFormData = {
            driver: {driverId:data.driverId,name:data.driverName,status:1},
            task: driverTasks.find(task => task.id === data.driverTaskId),
            estimatedCost: data.estimatedCost,
            date: newDate,
            frequency: newFrequency,
            timeUnit: TIME_UNITS.find(timeUnit => timeUnit.id === data.timeUnit),
            attachments: data.files ? data.files : [],
            notes: data.notes,
            reminder: data.alertBefore,
            reminderTimeUnit: data.alertBefore ? TIME_UNITS.find(timeUnit => timeUnit.id === data.alertBeforeTimeUnit) : null,
            pastDue: data.alertAfter,
            pastDueTimeUnit: data.alertAfter ? TIME_UNITS.find(timeUnit => timeUnit.id === data.alertAfterTimeUnit) : null
        };

        if (data.subscribers && data.subscribers?.length) {
            newFormData.subscribers = data.subscribers?.map(subscriber => {
                let options = [];

                if (subscriber.alert) options.push({ id: "Reminder", name: messages['reminder'] });

                if (subscriber.alertBefore) options.push({ id: "DueNow", name: messages['dueNow'] });

                if (subscriber.alertAfter) options.push({ id: "PastDue", name: messages['pastDue'] });
                
                return {
                    id: subscriber?.id,
                    contactId: subscriber?.contact?.id || subscriber?.contactId,
                    title: contactsList.find(cont => cont.id == subscriber?.contactId)?.title,
                    options: options
                }
            });
        }
        setFormData(newFormData);
        setTimeout(() => {
            formRef.setValues(newFormData)
        }, 100);
    }

    useEffect(() => {
        if (createDriverTaskResponse && createDriverTaskResponse.id) {
            dispatch(maintenanceMSDTSearchMaintenanceDriverTasks({}))
        }
    }, [createDriverTaskResponse])

    const handleScheduleDriverTask = () => {
        let data = {
            driverId: formData.driver.driverId,
            driverTaskId: formData.task.id,
            estimatedCost: formData.estimatedCost ? parseFloat(formData.estimatedCost) : 0,
            dueDate: formData.date.toISOString(),
            frequency: parseInt(formData.frequency),
            timeUnit: formData.timeUnit.id,
            alertBefore: formData.reminder || 0,
            alertBeforeTimeUnit: formData.reminderTimeUnit ? formData.reminderTimeUnit.id : null,
            alertAfter: formData.pastDue || 0,
            alertAfterTimeUnit: formData.pastDueTimeUnit ? formData.pastDueTimeUnit.id : null,
            notes: formData.notes || null,
            subscribers: formData.subscribers || null,
            fileIds: formData.attachments?.length ? formData.attachments?.map((attachment) => {
                if (attachment?.id || attachment?.Id) {
                    return attachment.id || attachment.Id
                }
            }) : []
        };

        //setting default date to start progress bar
        data.lastMaintenanceDate = moment(data.dueDate).subtract(formData.frequency, formData.timeUnit?.id.toLowerCase()).toISOString()

        if (scheduledDriverTask) {
            data.id = scheduledDriverTask.id;
        }
        dispatch(maintenanceMSDTCreateUpdateDriverScheduledTask(data))
    };

    const createDriverScheduledTaskAlert = () => {
        let alertsForUpdate = [];
        let alertsForDelete = [];

        alertsForUpdate = formData.subscribers?.map(alert => {
            let alrt = alert.options.find(alertType => alertType.name === messages['reminder']);
            let alertBefore = alert.options.find(alertType => alertType.name === messages['dueNow']);
            let alertAfter = alert.options.find(alertType => alertType.name === messages['pastDue']);

            return {
                id: alert.id || null,
                entityName: "DriverScheduledTask",
                entityId: scheduledDriverTask ? scheduledDriverTask.id : response.id,
                contactId: alert.contactId,
                alert: alrt ? 1 : 0,
                alertBefore: alertBefore ? 1 : 0,
                alertAfter: alertAfter ? 1 : 0
            }
        });

        if (scheduledDriverTask && scheduledDriverTask.subscribers && scheduledDriverTask.subscribers?.length) {
            alertsForDelete = scheduledDriverTask.subscribers.filter(subscriber => {
                return !alertsForUpdate.find(alert => alert.id === subscriber.id || alert.contactId === subscriber.contactId);
            });

            alertsForDelete = alertsForDelete?.map(alertForDelete => alertForDelete.id);
        }

        if (response && response.id && (alertsForUpdate?.length === 0 || !alertsForUpdate)
            && (alertsForDelete.length === 0 || !alertsForDelete)) {
            handleSuccess();
        } else {
            dispatch(maintenanceMSDTCreateEditAlertSubscriber({ updateAlerts: alertsForUpdate, deleteAlerts: alertsForDelete }))
        }
    }

    const checkTimeCombination = (timeUnit, timeValue) => {
        let returnValue;
        if (timeUnit) {
            switch (timeUnit) {
                case "Days":
                    returnValue = timeValue * 24
                    break
                case "Months":
                    returnValue = timeValue * 24 * 30
                    break
                case "Hours":
                    returnValue = timeValue
                    break
            }
        }
        return returnValue
    }

    const getDueDate = useCallback((newTimeUnit, newFrequency) => {
        let defaultDate = null;
        let currentFrequency = 0;

        if (newTimeUnit === "Days") {
            currentFrequency = getValidFrequency(newTimeUnit, newFrequency);
            defaultDate = moment(moment(), "DD-MM-YYYY").add(Number(currentFrequency), 'days');
        } else if (newTimeUnit === "Months") {
            currentFrequency = getValidFrequency(newTimeUnit, newFrequency);
            defaultDate = moment(moment(), "DD-MM-YYYY").add(Number(currentFrequency), 'M');
        } else if (newTimeUnit === "Hours") {
            currentFrequency = getValidFrequency(newTimeUnit, newFrequency);
            defaultDate = moment(moment(), "DD-MM-YYYY").add(Number(currentFrequency), 'hours');
        }
        return defaultDate?._d;
    });

    const getValidFrequency = useCallback((newTimeUnit, newFrequency) => {
        let currentFrequency = 0;
        if (newTimeUnit === "Days") {
            currentFrequency = newFrequency > 999 ? 999 : newFrequency;
        } else if (newTimeUnit === "Months") {
            currentFrequency = newFrequency > 120 ? 120 : newFrequency;
        } else if (newTimeUnit === "Hours") {
            currentFrequency = newFrequency > 99999 ? 99999 : newFrequency;
        }
        return currentFrequency;
    });

    useEffect(() => {
        setDrivers(OrderData(driversList, 'name'));
    }, [driversList]);

    let title = messages['scheduleDriverTask_title'];
    if (scheduledDriverTask) {
        title = `${messages['scheduleDriverTask_editTitle']} "${scheduledDriverTask?.driverTaskName}"`;
    }

    return (
        <Fragment>
            <Modal
                title={title}
                open={open}
                handleClose={handleClose}
                size="small"
                position="right"
                loading={loadingCreateUpdateDriverScheduledTask || loadingDriverTasks || loadingScheduledDriverTask || loadingDrivers || loadingContacts || loadingAlertSubscriberResponse}
                footer={(
                    <div>
                        <Button
                            onClick={handleClose}
                            variant='secondary'
                            style={{ marginRight: 8 }}
                        >
                            {messages['cancel']}
                        </Button>

                        <Button
                            onClick={() => {
                                formRef?.submit();
                            }}
                            variant='primary'
                        >
                            {scheduledDriverTask ? messages['scheduleDriverTask_update'] : messages['scheduleDriverTask_schedule']}
                        </Button>
                    </div>
                )}
            >
                <div style={{ padding: '18px 35px' }}>
                    <Form
                        ref={formRef.ref}
                        loading={false}
                        onValidSubmit={() => handleScheduleDriverTask()}
                        onChangeValues={() => { }}
                    >
                        <Form.Item
                            name="driver"
                            label={messages['scheduleDriverTask_driverInputLabel']}
                            rules={[
                                {
                                    required: true,
                                    message: messages['required_field']
                                }
                            ]}
                        >
                            <Select
                                id="driver"
                                placeholder={messages['scheduleDriverTask_driverInputPlaceholder']}
                                options={drivers || []}
                                isDisabled={scheduledDriverTask || driverId || loadingDrivers}
                                textField="name"
                                valueField="driverId"
                                onChange={(value) => {
                                    dispatch(maintenanceMSDTSearchDriverScheduledTasks({ id: value.driverId }))
                                    setFormData({ ...formData, driver: value });
                                }}
                                isSearchable
                                value={formData.driver}
                            />
                        </Form.Item>
                        <Form.Item
                            name="task"
                            label={messages['scheduleDriverTask_taskInputLabel']}
                            rules={[
                                {
                                    required: true,
                                    message: messages['required_field']
                                }
                            ]}
                        >
                            <Select
                                id="task"
                                placeholder={messages['scheduleDriverTask_taskInputPlaceholder']}
                                options={tasks || []}
                                isDisabled={loadingDriverTasks || loadingListDriverScheduledTasks || scheduledDriverTask}
                                textField="name"
                                valueField="id"
                                isSearchable
                                onChange={(value) => {
                                    filterDriversByTask(value)
                                    setTask(value)
                                }}
                            />
                        </Form.Item>
                        <Form.Item
                            name="estimatedCost"
                            label={messages['updateService_costInputLabel']}
                            rules={[
                                {
                                    max: 1000000000,
                                    message: `${messages['max']}: 1000000000`
                                }
                            ]}
                        >
                            <InputNumeric
                                id="estimatedCost"
                                type="currency"
                                placeholder={messages['updateService_costInputPlaceholder']}
                                maxLength={12}
                                onChange={(value) => {
                                    value = value.replace(/[_-]/g, "");
                                    setFormData({ ...formData, estimatedCost: parseFloat(value) })
                                    setTimeout(() => { formRef.setValues({ estimatedCost: value }) }, 50);
                                }}
                                decimalPlaces={2}
                            />
                        </Form.Item>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <label className="input-normal-label" style={{ marginBottom: 18 }}>
                                    <Required />
                                    {messages['scheduleDriverTask_repeatEveryInputLabel']}
                                </label>
                            </Grid>
                            <Grid item xs={6} className="scheduled-driver-tasks-no-label">
                                <Form.Item
                                    name="frequency"
                                    label={messages['scheduleDriverTask_frequencyInputPlaceholder']}
                                    rules={[
                                        {
                                            required: true,
                                            message: messages['required_field']
                                        },
                                        {
                                            min: 1,
                                            message: `${messages['min']}: 1`
                                        },
                                        {
                                            max: formData?.timeUnit?.id === "Months" ? 120 : 99999,
                                            message: `${messages['scheduleDriverTask_frequencyMax']} ${formData.timeUnit?.id === "Months" ? 120 : 99999}`
                                        }
                                    ]}
                                >
                                    <InputNumeric
                                        id="frequency"
                                        type="number"
                                        placeholder={messages['scheduleDriverTask_frequencyInputPlaceholder']}
                                        onChange={(value) => {
                                            value = getValidFrequency(formData.timeUnit?.id, value);
                                            if (value) {
                                                if (value != formData?.frequency) {
                                                    setFormData({
                                                        ...formData,
                                                        frequency: value,
                                                        date: getDueDate(formData.timeUnit?.id, value),
                                                        reminder: null,
                                                        reminderTimeUnit: null,
                                                        pastDue: null,
                                                        pastDueTimeUnit: null
                                                    });
                                                    setTimeout(() => {
                                                        formRef.setValues({
                                                            ...formData,
                                                            frequency: value,
                                                            date: getDueDate(formData.timeUnit?.id, value),
                                                            reminder: null,
                                                            reminderTimeUnit: null,
                                                            pastDue: null,
                                                            pastDueTimeUnit: null
                                                        })
                                                    }, 50);
                                                }
                                            } else setFormData({ ...formData, frequency: null, date: null })
                                        }}
                                        isDisabled={!formData.timeUnit}
                                    />
                                </Form.Item>
                            </Grid>
                            <Grid item xs={6} className="scheduled-driver-tasks-no-label">
                                <Form.Item
                                    name="timeUnit"
                                    label={messages['scheduleDriverTask_timeUnitInputPlaceholder']}
                                    rules={[
                                        {
                                            required: true,
                                            message: messages['required_field']
                                        }
                                    ]}
                                >
                                    <Select
                                        id="timeUnit"
                                        placeholder={messages['scheduleDriverTask_timeUnitInputPlaceholder']}
                                        value={formData.timeUnit}
                                        options={TIME_UNITS || []}
                                        onChange={(value) => {
                                            let defaultDate = null;
                                            let newFrequency = formData?.frequency;
                                            if (formData.frequency) {
                                                switch (value.id) {
                                                    case "Days":
                                                        newFrequency = newFrequency > 999 ? 999 : newFrequency;
                                                        defaultDate = moment(moment(), "DD-MM-YYYY").add(Number(newFrequency), 'days');
                                                        break
                                                    case "Months":
                                                        newFrequency = newFrequency > 120 ? 120 : newFrequency;
                                                        defaultDate = moment(moment(), "DD-MM-YYYY").add(Number(newFrequency), 'M');
                                                        break
                                                    case "Hours":
                                                        newFrequency = newFrequency > 99999 ? 99999 : newFrequency;
                                                        defaultDate = moment(moment(), "DD-MM-YYYY").add(Number(newFrequency), 'hours');
                                                        break
                                                }
                                            }
                                            setFormData({
                                                ...formData,
                                                timeUnit: value,
                                                frequency: newFrequency,
                                                reminder: null,
                                                reminderTimeUnit: null,
                                                pastDue: null,
                                                pastDueTimeUnit: null,
                                                date: defaultDate?._d
                                            });
                                            setTimeout(() => {
                                                formRef.setValues({
                                                    ...formData,
                                                    timeUnit: value,
                                                    frequency: newFrequency,
                                                    reminder: null,
                                                    reminderTimeUnit: null,
                                                    pastDue: null,
                                                    pastDueTimeUnit: null,
                                                    date: defaultDate?._d
                                                })
                                            }, 50);
                                        }}
                                        textField="name"
                                        valueField="id"
                                        className="schedule-driver-tasks-selector"
                                        isSearchable
                                    />
                                </Form.Item>
                            </Grid>
                        </Grid>
                        <Form.Item
                            name="date"
                            label={messages['scheduleDriverTask_dateInputLabel']}
                            rules={[
                                {
                                    required: true,
                                    message: messages['required_field']
                                }
                            ]}
                        >
                            <DatePicker
                                id="date"
                                showTimePicker
                                calendarPosition="bottom-end"
                                placeholder={messages['scheduleDriverTask_dateInputPlaceholder']}
                                format={GetFormatForMoment(user.dateformat)}
                                minDate={new Date()}
                                onChange={(value) => {
                                    if (moment().isAfter(moment(value), 'minutes')) {
                                        NotificationManager.warning(
                                            messages['scheduleDriverTask_wait'],
                                            messages['scheduleDriverTask_invalidTime'],
                                            3000,
                                            null,
                                            null,
                                            'success',
                                        );
                                    }
                                    else setFormData({ ...formData, date: value });
                                }}
                                isDisabled={!formData.timeUnit || !formData.frequency}
                            />
                        </Form.Item>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <label className="input-normal-label" style={{ marginBottom: 18 }}>
                                    {messages['scheduleDriverTask_alertsInputLabel']}
                                </label>
                            </Grid>
                            <Grid item xs={6}>
                                <Form.Item
                                    name="reminder"
                                    label={messages['scheduleDriverTask_reminderInputLabel']}
                                    rules={[
                                        {
                                            required: formData?.frequency,
                                            message: messages['required_field'],
                                        },
                                        {
                                            min: 1,
                                            minMessage: `${messages['min']}: 1`
                                        }
                                    ]}
                                >
                                    <InputNumeric
                                        id="reminder"
                                        type="number"
                                        placeholder={messages['scheduleDriverTask_reminderInputPlaceholder']}
                                        onChange={(value) => {
                                            if (formData.reminderTimeUnit) {
                                                const totalFrequencyHours = checkTimeCombination(formData.timeUnit?.id, formData.frequency)
                                                const totalCurrentHours = checkTimeCombination(formData.reminderTimeUnit?.id, value)
                                                if (Number(totalCurrentHours) >= Number(totalFrequencyHours)) {
                                                    setTimeout(() => {
                                                        formRef.setValues({ reminder: formData?.reminder });
                                                        setFormData({ ...formData, reminder: formData?.reminder });
                                                    }, 50);
                                                    NotificationManager.warning(
                                                        messages['scheduleDriverTask_wait'],
                                                        messages['reminder_time_invalid'],
                                                        3000,
                                                        null,
                                                        null,
                                                        'success',
                                                    );
                                                    return
                                                }
                                            }
                                            setFormData({ ...formData, reminder: value });
                                        }}
                                        isDisabled={!formData.frequency || !formData.timeUnit}
                                        maxlength={8}
                                    />
                                </Form.Item>
                            </Grid>
                            <Grid item xs={6} className="scheduled-driver-tasks-hidden-label">
                                <Form.Item
                                    name="reminderTimeUnit"
                                    label={messages['scheduleDriverTask_timeUnitInputPlaceholder']}
                                    rules={[
                                        {
                                            required: formData?.reminder,
                                            message: messages['required_field']
                                        }
                                    ]}
                                >
                                    <Select
                                        id="reminderTimeUnit"
                                        placeholder={messages['scheduleDriverTask_reminderTimeUnitInputPlaceholder']}
                                        options={TIME_UNITS || []}
                                        onChange={(value) => {
                                            let validation = true
                                            if (formData.reminder) {
                                                const totalFrequencyHours = checkTimeCombination(formData.timeUnit?.id, formData.frequency)
                                                const totalCurrentHours = checkTimeCombination(value?.id, formData.reminder)
                                                if (Number(totalCurrentHours) >= Number(totalFrequencyHours)) {
                                                    setFormData({ ...formData, reminderTimeUnit: null });
                                                    setTimeout(() => { formRef.setValues({ reminderTimeUnit: null }) }, 50);
                                                    validation = false
                                                    NotificationManager.warning(
                                                        messages['scheduleDriverTask_wait'],
                                                        messages['reminder_time_invalid'],
                                                        3000,
                                                        null,
                                                        null,
                                                        'success',
                                                    );
                                                    return
                                                }
                                            }
                                            setFormData({ ...formData, reminderTimeUnit: validation && value });
                                        }}
                                        isClearable
                                        isDisabled={!formData.frequency || !formData.timeUnit}
                                        textField="name"
                                        valueField="id"
                                        className="schedule-driver-tasks-selector"
                                        isSearchable
                                    />
                                </Form.Item>
                            </Grid>
                            <Grid item xs={6}>
                                <Form.Item
                                    name="pastDue"
                                    label={messages['scheduleDriverTask_pastDueInputLabel']}
                                    rules={[
                                        {
                                            required: formData?.frequency,
                                            message: messages['required_field']
                                        },
                                        {
                                            min: 1,
                                            message: `${messages['min']}: 1`
                                        }
                                    ]}
                                >
                                    <InputNumeric
                                        id="pastDue"
                                        type="number"
                                        placeholder={messages['scheduleDriverTask_pastDueInputPlaceholder']}
                                        onChange={(value) => {
                                            if (formData.pastDueTimeUnit) {
                                                const totalFrequencyHours = checkTimeCombination(formData.timeUnit?.id, formData.frequency)
                                                const totalCurrentHours = checkTimeCombination(formData.pastDueTimeUnit?.id, value)
                                                if (Number(totalCurrentHours) >= Number(totalFrequencyHours)) {
                                                    setTimeout(() => { formRef.setValues({ pastDue: formData?.pastDue }) }, 50);
                                                    return NotificationManager.warning(
                                                        messages['scheduleDriverTask_wait'],
                                                        messages['reminder_time_invalid'],
                                                        3000,
                                                        null,
                                                        null,
                                                        'success',
                                                    );
                                                }
                                            }
                                            setFormData({ ...formData, pastDue: value });
                                        }}
                                        isDisabled={!formData.frequency || !formData.timeUnit}
                                        maxlength={5}
                                    />
                                </Form.Item>
                            </Grid>
                            <Grid item xs={6} className="scheduled-driver-tasks-hidden-label">
                                <Form.Item
                                    name="pastDueTimeUnit"
                                    label={messages['scheduleDriverTask_timeUnitInputPlaceholder']}
                                    rules={[
                                        {
                                            required: formData?.pastDue,
                                            message: messages['required_field']
                                        }
                                    ]}
                                >
                                    <Select
                                        id="pastDueTimeUnit"
                                        placeholder={messages['scheduleDriverTask_pastDueInputPlaceholder']}
                                        options={TIME_UNITS || []}
                                        onChange={(value) => {
                                            let validation = true
                                            if (formData.pastDue) {
                                                const totalFrequencyHours = checkTimeCombination(formData.timeUnit?.id, formData.frequency);
                                                const totalCurrentHours = checkTimeCombination(value?.id, formData.pastDue);

                                                if (Number(totalCurrentHours) >= Number(totalFrequencyHours)) {
                                                    setTimeout(() => { formRef.setValues({ pastDueTimeUnit: null }) }, 100);
                                                    validation = false
                                                    NotificationManager.warning(
                                                        messages['scheduleDriverTask_wait'],
                                                        messages['reminder_time_invalid'],
                                                        3000,
                                                        null,
                                                        null,
                                                        'success',
                                                    );
                                                }
                                            }
                                            setFormData({ ...formData, pastDueTimeUnit: validation && value });
                                        }}
                                        isSearchable
                                        isClearable
                                        isDisabled={!formData.frequency || !formData.timeUnit}
                                        textField="name"
                                        valueField="id"
                                        className="schedule-driver-tasks-selector"
                                    />
                                </Form.Item>
                            </Grid>
                        </Grid>
                        <Form.Item
                            name="subscribers"
                            label={messages['scheduleDriverTask_subscribersInputLabel']}
                        >
                            <SelectMenu
                                id="subscribers"
                                options={contacts}
                                isLoading={loadingContacts}
                                textField="title"
                                valueField="contactId"
                                placeholder={messages["scheduleVehicleService_alert_placeholder"]}
                                extraOptions={ALERT_TYPES || []}
                                extraOptionstextField="name"
                                extraOptionsvalueField="id"
                                extraOptionsRequiredMessage={messages["scheduleVehicleService_alert_error_message"]}
                                buttonLabel={messages["scheduleVehicleService_alert_button_label"]}
                                onChange={(value) => setFormData({ ...formData, subscribers: value })}
                                type="multi-checkbox"
                            />
                        </Form.Item>
                        <Form.Item
                            name="attachments"
                            label={messages['scheduleDriverTask_attachmentsInputLabel']}
                        >
                            <FileUpload
                                id="attachments"
                                placeholder={messages['completeMaintenanceService_select_files']}
                                types="image/*,.txt,.doc,.docx,.pdf,.csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                maxSize={4}
                                maxSizeMessage={`${messages['max']}: 4MB`}
                                helpText={messages['attachmentsFilesAllowed']}
                                uploadAttachment={(data) => { dispatch(uploadAttachment(data)) }}
                                uploadedAttachment={uploadedAttachment}
                                loadingUploadFile={loadingUploadFile}
                                onChange={(value) => setFormData({ ...formData, attachments: value })}
                            />
                        </Form.Item>
                        <Form.Item
                            label={messages['scheduleDriverTask_notesInputLabel']}
                            name="notes"
                        >
                            <TextArea
                                id="notes"
                                placeholder={messages['scheduleDriverTask_notesInputPlaceholder']}
                                maxLength={500}
                                value={formData.notes || ""}
                                onChange={(value) => setFormData({ ...formData, notes: value })}
                            />
                        </Form.Item>
                        {
                            selectedTask?.description
                                ?
                                <Form.Item
                                    label={messages['scheduleDriverTask_taskNameInputLabel']}
                                    name="maintenanceServiceNotes"
                                >
                                    <TextArea
                                        id="maintenanceServiceNotes"
                                        placeholder={messages['scheduleVehicleService_notesInputPlaceholder']}
                                        maxLength={500}
                                        value={selectedTask?.description}
                                        onChange={() => { }}
                                        isDisabled
                                    />
                                </Form.Item>
                                : <></>
                        }
                        {
                            selectedTask?.files
                                && selectedTask?.files.length > 0 ?
                                <Form.Item
                                    name="maintenanceServiceAttachments"
                                    label={messages['scheduleDriverTask_attachmentsTaskLabel']}
                                >
                                    <FileUpload
                                        id="maintenanceServiceAttachments"
                                        placeholder={messages['scheduleDriverTask_attachmentsInputPlaceholder']}
                                        types="image/*,.txt,.doc,.docx,.pdf,.csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                        maxSize={4}
                                        maxSizeMessage={`${messages['max']}: 4MB`}
                                        helpText={messages['attachmentsFilesAllowed']}
                                        value={selectedTask?.files}
                                        onChange={(files) => { }}
                                        isDisabled
                                    />
                                </Form.Item>
                                : <></>
                        }
                    </Form>
                </div>
                <NotificationContainer />
            </Modal>
            {openCreateDriverTasks && <CreateEditDriverTask />}
        </Fragment >
    );
};

export default ScheduleDriverTask